import { ProviderTotalBalance } from '@kr/models';

export function getTotalBalanceMock(): ProviderTotalBalance {
  const balance = (Math.random() * 10000).toFixed(5);

  return {
    balance,
    currencyId: 1,
    provider: {
      id: 1,
      type: 'ALT',
      name: 'Alt',
      icon_background_color: '#ffffff',
      icon_color_of_letter: '#0e5187',
      icon_letter: 'A',
      can_create_wallets: true,
    },
  };
}
